import corporatetrainingprograms_background from "../images/corporatetrainingprograms/corporatetrainingprograms_background.png";
import corporatetrainingprograms1 from "../images/corporatetrainingprograms/corporatetrainingprograms1.png";
import corporatetrainingprograms2 from "../images/corporatetrainingprograms/corporatetrainingprograms2.png";
import corporatetrainingprograms3 from "../images/corporatetrainingprograms/corporatetrainingprograms3.png";
import corporatetrainingprograms4 from "../images/corporatetrainingprograms/corporatetrainingprograms4.png";
import corporatetrainingprograms5 from "../images/corporatetrainingprograms/corporatetrainingprograms5.png";
import corporatetrainingprograms6 from "../images/corporatetrainingprograms/corporatetrainingprograms6.png";

export const corporatetrainingprogramsslides = [

/* ---------------- 📚 SLIDE 1 — TRAINING INTRO ---------------- */
[
  {
    id: 1,
    type: "background",
    src: corporatetrainingprograms_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 25,
    type: "image",
    src: corporatetrainingprograms1,
    x: 30,
    y: 120,
    width: 200,
    height: 200,
    shape: "pentagon",
    stroke: "#c295e0",
    strokeWidth: 2
  },

  {
    id: 30,
    type: "image",
    src: corporatetrainingprograms2,
    x: 30,
    y: 310,
    width: 200,
    height: 200,
    stroke: "#c295e0",
    strokeWidth: 2
  },

  {
    id: 31,
    type: "image",
    src: corporatetrainingprograms3,
    x: 30,
    y: 520,
    width: 200,
    height: 200,
    shape: "pentagon",
    stroke: "#c295e0",
    strokeWidth: 2
  },

  {
    id: 2,
    type: "text",
    text: "📚 Corporate Training Program",
    x: 200,
    y: 80,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#c295e0",
  },

  {
    id: 4,
    type: "text",
    text: "Learn • Grow • Excel",
    x: 300,
    y: 130,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 5,
    type: "text",
    text: "Empowering professionals with skills,",
    x: 260,
    y: 200,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 6,
    type: "text",
    text: "leadership, and workplace excellence",
    x: 260,
    y: 230,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 7,
    type: "text",
    text: "✔ Leadership Development",
    x: 270,
    y: 400,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 8,
    type: "text",
    text: "✔ Team Collaboration",
    x: 270,
    y: 460,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 9,
    type: "text",
    text: "✔ Productivity Enhancement",
    x: 270,
    y: 520,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 10,
    type: "text",
    text: "✔ Strategic Thinking",
    x: 270,
    y: 580,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#c295e0"
  }
],


/* ---------------- 📅 SLIDE 2 — TRAINING DETAILS ---------------- */
[
  {
    id: 11,
    type: "background",
    src: corporatetrainingprograms_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 26,
    type: "image",
    src: corporatetrainingprograms4,
    x: 30,
    y: 120,
    width: 200,
    height: 200,
    shape: "pentagon",
    stroke: "#c295e0",
    strokeWidth: 2
  },

  {
    id: 27,
    type: "image",
    src: corporatetrainingprograms5,
    x: 30,
    y: 310,
    width: 200,
    height: 200,
    stroke: "#c295e0",
    strokeWidth: 2
  },

  {
    id: 33,
    type: "image",
    src: corporatetrainingprograms6,
    x: 30,
    y: 520,
    width: 200,
    height: 200,
    shape: "pentagon",
    stroke: "#c295e0",
    strokeWidth: 2
  },

  {
    id: 12,
    type: "text",
    text: "📌 You're Invited",
    x: 320,
    y: 190,
    fontSize: 28,
    fontFamily: "Open Sans",
    fill: "#c295e0"
  },

  {
    id: 13,
    type: "text",
    text: "📅 20 March 2026",
    x: 320,
    y: 250,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 14,
    type: "text",
    text: "⏰ 9:30 AM",
    x: 350,
    y: 300,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 15,
    type: "text",
    text: "📍 Training Center, Vijayawada",
    x: 310,
    y: 350,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 16,
    type: "text",
    text: "Build Skills • Drive Success",
    x: 340,
    y: 500,
    fontSize: 17,
    fontFamily: "Open Sans",
    fill: "#c295e0"
  },

  {
    id: 17,
    type: "text",
    text: "Invest in learning today,",
    x: 360,
    y: 550,
    fontSize: 13,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 18,
    type: "text",
    text: "lead with confidence tomorrow",
    x: 340,
    y: 600,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#c295e0"
  },

  {
    id: 19,
    type: "text",
    text: "📚 Training 2026",
    x: 360,
    y: 680,
    fontSize: 26,
    fontFamily: "Dancing Script",
    fill: "#c295e0"
  }
]

];